import { AuthError } from '../server-threads';
import type { DesktopRecordingBridge } from './desktop-recording';

export interface DesktopGoogleSignInOptions {
  inviteCode?: string;
  companyName?: string;
}

interface DesktopBridge {
  signInWithGoogle(options?: DesktopGoogleSignInOptions): Promise<void>;
}

interface DesktopAuthResult {
  ok: true;
  error?: never;
}

interface DesktopAuthFailure {
  ok: false;
  error: string;
}

interface DesktopRawBridge extends Partial<DesktopRecordingBridge> {
  signInWithGoogle(
    options?: DesktopGoogleSignInOptions,
  ): Promise<DesktopAuthResult | DesktopAuthFailure>;
}

declare global {
  interface Window {
    ponevaDesktop?: DesktopRawBridge;
  }
}

export function desktopBridge(): DesktopBridge | null {
  const bridge = typeof window !== 'undefined' ? window.ponevaDesktop : undefined;
  if (!bridge) return null;
  return {
    signInWithGoogle: async (options) => {
      const result = await bridge.signInWithGoogle(options);
      if (!result || result.ok !== true) {
        throw new AuthError(result?.error || 'server_unavailable');
      }
    },
  };
}

export function isDesktopShell(): boolean {
  return desktopBridge() !== null;
}
